import React from 'react';
import PropTypes from 'prop-types';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import b from 'b_';
import cn from 'classnames';
import UDSpinner from '../UD/Fragments/UDSpinner';
import Icon from '../Icon/Icon';
import './ConsoleFragments.css';

const block = b.lock('ConsoleTable');

const ConsoleTable = observer((props) => {
    const {
        className,
        rowClassName,
        cellsContainerClassName,
        cellClassName,
        columns,
        items,
        focusedItemId,
        loading,
        expandedSection,
        onRowClick,
        onRowDoubleClick,
        ...otherProps
    } = props;
    return <div
        className={cn(block(), className)}
        {...otherProps}
    >
        <div className={cn(block('Row', { header: true }), rowClassName && b(rowClassName, { header: true }))}>
            <div className={block('CellsContainer', { rowsCanExpand: !!expandedSection })}>
                {columns.map((c) =>
                    <div
                        key={c.name}
                        className={cn(block('Cell', { header: true, type: c.name }),
                            cellClassName && b(cellClassName, { header: true, type: c.name, ...c.modifiers }))}
                    >{c.title}</div>
                )}
            </div>
        </div>
        {items && !loading ? items.map((item, itemIndex) => {
            const canExpand = expandedSection && expandedSection.canExpand(item, itemIndex);
            const isExpanded = expandedSection && expandedSection.isExpanded(item, itemIndex);
            return <div
                key={item.id}
                className={cn(block('Row'), rowClassName)}
                onClick={() => onRowClick && onRowClick(item)}
                onDoubleClick={() => onRowDoubleClick && onRowDoubleClick(item)}
            >
                <div
                    className={
                        cn(block('CellsContainer', { focused: item.id === focusedItemId }),
                            cellsContainerClassName)}
                >
                    {expandedSection ? <div className={block('ExpandToggleContainer')}>
                        {canExpand ? <Icon
                            className={block('ExpandToggle', { isExpanded })}
                            type="keyboard_arrow_down"
                            onClick={() => expandedSection.toggleExpand(item, itemIndex)}
                        /> : null}
                    </div> : null}
                    {columns
                        .filter((c) => !c.shouldRender || c.shouldRender(item, itemIndex))
                        .map((c) => <div
                            key={c.name}
                            className={cn(block('Cell', { type: c.name }),
                                cellClassName && b(cellClassName, { type: c.name, ...c.modifiers }))}
                        >{c.render(item, itemIndex)}</div>)}
                </div>
                {isExpanded ? <div className={block('ExpandedSection')}>
                    {expandedSection.render(item, itemIndex)}
                </div> : null}
            </div>;
        }) : null}

        {loading ? <div className={block('SpinnerWrapper')}>
            <UDSpinner
                className={block('Spinner')}
                type="small"
            />
        </div> : null}
    </div>;
});

ConsoleTable.propTypes = {
    items: MobxPropTypes.arrayOrObservableArray,
    columns: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        title: PropTypes.node,
        render: PropTypes.func,
        shouldRender: PropTypes.func,
    })),
    expandedSection: PropTypes.shape({
        canExpand: PropTypes.func.isRequired,
        isExpanded: PropTypes.func.isRequired,
        toggleExpand: PropTypes.func.isRequired,
        render: PropTypes.func.isRequired,
    }),
    rowClassName: PropTypes.string,
    cellsContainerClassName: PropTypes.string,
    cellClassName: PropTypes.string,
    focusedItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loading: PropTypes.bool,
    onRowClick: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
};

export default ConsoleTable;
